import curry from 'lodash.curry'
import { mix } from 'polished'

const mixWhite = curry((otherColor, weight) => mix(weight, '#fff', otherColor))
const mixBlack = curry((otherColor, weight) => mix(weight, '#000', otherColor))

export const toneGenerator = curry((steps, level, color) => {
  return (level < 0 ? mixWhite : mixBlack)(color, Math.abs(level) / steps)
})

/**
 * @param {number} level
 * @param {string} color
 */
export const tone = toneGenerator(10)
